import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rentable-item-test-diaglog',
  templateUrl: './rentable-item-test-diaglog.component.html',
  styleUrls: ['./rentable-item-test-diaglog.component.css']
})
export class RentableItemTestDiaglogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
